module.exports = __webpack_public_path__ + "assets/img/20_50_big.260b63f2.jpg";